import { render, staticRenderFns } from "./groupOrderCorrectForm.vue?vue&type=template&id=88c1c6da&"
import script from "./groupOrderCorrectForm.vue?vue&type=script&lang=js&"
export * from "./groupOrderCorrectForm.vue?vue&type=script&lang=js&"
import style0 from "./groupOrderCorrectForm.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports